import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";
import SmoothScroll from "./SmoothScroll";

function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("cmc_consent")) setShow(true);
  }, []);
  if (!show) return null;
  return (
    <div className="no-print fixed bottom-5 left-5 z-40 max-w-sm glass rounded-2xl p-4 text-sm" role="dialog" aria-label="Cookie consent">
      <p className="text-brand-muted leading-relaxed">
        We use cookies and analytics to improve your experience. By using this site you agree to our use of cookies.
      </p>
      <div className="mt-3 flex gap-2">
        <button
          data-testid="cookie-accept"
          onClick={() => { localStorage.setItem("cmc_consent", "1"); setShow(false); }}
          className="bg-brand-blue text-white px-4 py-2 rounded-full text-xs font-semibold"
        >
          Accept
        </button>
        <button
          data-testid="cookie-dismiss"
          onClick={() => setShow(false)}
          className="px-4 py-2 rounded-full text-xs font-semibold hover:bg-black/5"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}

export default function Layout() {
  return (
    <>
      <SmoothScroll />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingActions />
      <CookieConsent />
    </>
  );
}
